import React, { useRef, useState } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const ContactUs = () => {
    const form = useRef();
    const [successMessage, setSuccessMessage] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                'service_mnf6trq', // replace with your EmailJS Service ID
                'template_uy1qmij', // replace with your EmailJS Template ID
                form.current,
                '7XcVIAO0rCQHcNoz6' // replace with your EmailJS Public Key
            )
            .then(
                (result) => {
                    console.log(result.text);
                    setSuccessMessage('Message sent successfully!');
                    e.target.reset(); // reset form
                },
                (error) => {
                    console.log(error.text);
                    setSuccessMessage('Failed to send message. Please try again.');
                }
            );
    };

    return (
        <div className="font-sans text-gray-800">
            {/* Banner Section */}
            <div
                className="rts-banner-area relative bg-gray-900 py-16 md:py-20"
                style={{
                    backgroundImage: "url('assets/images/newimages/contactus.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="container mx-auto px-4 relative z-10">
                    <div className="text-center max-w-3xl mx-auto">
                        <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
                            Contact <span className="text-[#00A3A1]">Us</span>
                        </h1>

                        <Link to="/contact-us">
                            <button className="px-6 py-2 bg-[#00A3A1] hover:bg-teal-600 text-white font-medium rounded-md transition duration-300">
                                Request query below
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Contact Content Section */}
            <div className="rts-contact-area-page py-6">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col lg:flex-row items-center">
                        {/* Left Side - Contact Info */}
                        <div className="lg:w-1/2 lg:pr-12 mb-12 lg:mb-0">
                            <div className="contact-main-wrapper-left">
                                <span className="text-[#00A3A1] font-semibold block mb-2">Get In Touch</span>
                                <h3 className="text-3xl md:text-4xl text-[#063970] font-bold mb-6 leading-tight">
                                    We are always ready to help you <br />
                                    and answer your questions
                                </h3>
                                <p className="text-[#000] mb-8">
                                    Our team is available to assist you with any inquiries about our construction services,
                                    materials, or project consultations.
                                </p>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* Call Center */}
                                    <div className="quick-contact-page-1 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                        <div className="icon mb-2">
                                            <img
                                                src="assets/images/contact/01.svg"
                                                alt="Phone Icon"
                                                className="w-12 h-12"
                                            />
                                        </div>
                                        <h5 className="text-xl font-bold mb-2 text-[#063970]">Call Center</h5>
                                        <p className="text-[#000]">
                                            <a href="tel:+971503118846" className="hover:text-[#063970]">+971 50 311 8846</a>
                                        </p>

                                        <div className="text-[#000] mt-2 space-y-2">
                                            <div className='flex gap-2 items-center'>
                                                <FaEnvelope className="text-gray-600 text-sm" />
                                                <a href="mailto:gbd@omanyefz.com" className="hover:text-blue-600 text-sm">
                                                    gbd@omanyefz.com
                                                </a>
                                            </div>
                                            <div className='flex gap-2 items-center'>
                                                <FaEnvelope className="text-gray-600 text-sm" />
                                                <a href="mailto:gbd.omanyefz@gmail.com" className="hover:text-blue-600 text-sm">
                                                    gbd.omanyefz@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Our Office */}
                                    <div className="quick-contact-page-1 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                                        <div className="icon mb-2">
                                            <img
                                                src="assets/images/contact/02.svg"
                                                alt="Location Icon"
                                                className="w-12 h-12"
                                            />
                                        </div>
                                        <h5 className="text-xl font-bold mb-2 text-[#063970]">Our Office</h5>
                                        <p className="text-[#000]">
                                            FOB 51927 Compass Building,<br />
                                            Al Shohoda Road,<br />
                                            Al Hamra Industrial Zone
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Contact Form */}
                        <div className="lg:w-1/2">
                            <div className="contact-form-area-wrapper bg-white p-8 rounded-xl shadow-lg">
                                <h4 className="text-2xl font-bold text-[#063970] mb-6">Let's Get in Touch / Share Requirements </h4>
                                <form ref={form} onSubmit={sendEmail} className="space-y-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="single">
                                            <input
                                                type="text"
                                                name="user_name"
                                                placeholder="Your Name"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                required
                                            />
                                        </div>
                                        <div className="single">
                                            <input
                                                type="tel"
                                                name="user_phone"
                                                placeholder="Phone Number"
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="single">
                                        <input
                                            type="email"
                                            name="user_email"
                                            placeholder="Email Address"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </div>
                                    <div className="single">
                                        <textarea
                                            name="message"
                                            placeholder="Type Your Message"
                                            rows="5"
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            required
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="rts-btn btn-primary w-full md:w-auto px-8 py-3 bg-[#00a3A1] hover:bg-[#0a8f8d] text-white font-bold rounded-lg transition duration-300"
                                    >
                                        Send Message
                                    </button>
                                    {successMessage && (
                                        <p className="text-green-600 mt-2">{successMessage}</p>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <div className="container mx-auto px-4 py-4">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl text-[#063970] font-bold mb-6">Our Location</h3>
                    <div className="aspect-w-16 aspect-h-9">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3596.1890042548685!2d55.78368562370279!3d25.665028662596168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef60bee567a253b%3A0x80fd444807765d7!2sRAKEZ%20Compass%20Coworking%20Centre!5e0!3m2!1sen!2sin!4v1750503855124!5m2!1sen!2sin"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="rounded-lg"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
